import React, { ReactElement } from 'react';
import { Row, Alert } from '@dexma/ui-components';

import StyledGrid from 'adapter/in/dashboards/pages/Dashboard/style';
import DashboardPageHeaderContainer from 'adapter/in/dashboards/containers/Dashboard/Header';
import Dashboard from 'domain/entity/dashboard';
import withLoading, { ViewState } from 'adapter/in/common/hoc/withLoading';

import { StyledAnimationDiv } from 'adapter/in/common/style';
import { AlertMessageType } from 'adapter/in/common/context/Alert';
import ViewSelectorContainer from 'adapter/in/dashboards/containers/ViewSelectorContainer/ViewSelectorContainer';
import { StyledAlertType } from 'adapter/in/common/components/Home/Home';

export type DashboardPageProps = ViewState<Dashboard> & {
    onFullscreen: () => void;
    fullscreenActive: boolean;
    alertMessage: AlertMessageType;
    alertType?: StyledAlertType;
    animationStyle: React.CSSProperties;
    showAlert: boolean;
};

export const DashboardPage = (props: DashboardPageProps): ReactElement => {
    const { data: dashboard, onFullscreen, fullscreenActive, alertMessage, alertType, animationStyle, showAlert } = props;

    return (
        <StyledGrid fluid data-testid='dashboard' $showAlert={showAlert}>
            <StyledAnimationDiv $animationStyle={animationStyle}>
                <Alert
                    description={alertMessage?.toString()}
                    type={alertType as StyledAlertType}
                    showIcon
                />
                <DashboardPageHeaderContainer dashboard={dashboard} onFullscreen={onFullscreen} fullscreenActive={fullscreenActive} />
                <Row className='layout'>
                    <ViewSelectorContainer isEditMode={false} dashboardId={dashboard.id} isEditingLayout={false} />
                </Row>
            </StyledAnimationDiv>
        </StyledGrid>
    );
};

export default withLoading(DashboardPage);
